import { taskGlobal } from '@frameio/async-hooks/task-global';
import { createIntl } from './create';
import { type IntlShape } from './types';

export const FALLBACK = createIntl({ locale: 'en-fallback' });

const fallbacks = taskGlobal<{ context: IntlShape }[]>(() => [
  { context: FALLBACK },
]);

export function notFound(): IntlShape {
  const all = fallbacks();
  return all[all.length - 1]?.context ?? FALLBACK;
}

export function provideFallback(context: IntlShape, source?: string) {
  const fallback = { context, source };
  const current = fallbacks();
  current.push(fallback);
  return () => {
    const index = current.indexOf(fallback);
    if (index !== -1) {
      current.splice(index, 1);
    }
  };
}

if (typeof window !== 'undefined') {
  (window as any).fallbacks = fallbacks;
}
